import { COMMANDER_VOLATILE_DATA_POOLING_INTERVAL } from '../../commander/api/Constants';

/** milliseconds */
export const CU_POLLING_INTERVAL = COMMANDER_VOLATILE_DATA_POOLING_INTERVAL;
